import { Button, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { copyUrl } from "./carouselHelpers";
import { useCarouselContext } from "../../context/CarouselContext";

const ImageTag: React.FC = () => {
  const { selectedImage } = useCarouselContext();
  if (!selectedImage || selectedImage.tag === "Unassigned") return <></>;

  const [copied, setCopied] = useState(false);

  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    copyUrl(setCopied);
  };

  return (
    <Tooltip title={copied ? "Copied!" : "Copy iFrame link"}>
      <Button
        onClick={handleCopy}
        size="small"
        variant="contained"
        sx={{
          minWidth: 40,
          padding: "6px",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          color: "#fff",
          fontSize: '0.75rem',
          lineHeight: 1.2,
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
          },
        }}
      >
        {selectedImage.tag}
      </Button>
    </Tooltip>
  );
};

export default ImageTag;
